import { Sidebar } from 'flowbite-react';
import { SocialIcon } from 'react-social-icons';
import { FaPhone, FaMapMarker } from 'react-icons/fa'; 


function SideBar() {
  return (
    < div className="sidebar-container">
    <Sidebar>

     <Sidebar.Logo>
        <img
          className="custom-logo"
          src="https://i.imgur.com/lWiqHSf.jpg"
          alt="Logo"
        />
        <span className="sidebar-title"> Hiba Qutbuddin Habib </span>
        <span className="sidebar-slogan">MSc Student In Information and Communication Technology </span>
      </Sidebar.Logo>

      <Sidebar.Items>
        <Sidebar.ItemGroup>
          <Sidebar.Item href="#" className="mb-4" >
          <SocialIcon network="email" url="mailto:hibqut1@gmail.com" className="mr-2" style={{ height: 30, width: 30, marginRight:10, marginBottom:10 }} />
            Email
          </Sidebar.Item>

          <Sidebar.Item href="tel:+46700374460" className="mb-4" >
          <FaPhone className="mr-2" style={{ height: 30, width: 30, marginRight:10, marginBottom:10}}/>
          Mobile
          </Sidebar.Item >

          <Sidebar.Item href="#" className="mb-4" >
          <SocialIcon network="github" url="https://github.com/HQUT?tab=repositories" className="mr-2" style={{ height: 30, width: 30, marginRight:10, marginBottom:10}}/>
             GitHub
          </Sidebar.Item >
          
          <Sidebar.Item href="#"  className="mb-4" >
          <SocialIcon network="linkedin" url="https://www.linkedin.com/in/hiba-qutbuddin-habib-713734231/" className="mr-2" style={{ height: 30, width: 30, marginRight:10 }} />
             linkedin
          </Sidebar.Item>

          <Sidebar.Item href="https://maps.app.goo.gl/R78SXsB98Dz35sbq8"  className="mb-5" >
          <FaMapMarker className="mr-2" style={{ height: 30, width: 30, marginRight:10, marginTop: 10}} /> 
          Address
          </Sidebar.Item>

        </Sidebar.ItemGroup>
      </Sidebar.Items>
    </Sidebar>
    </div>
  );
}
export default SideBar;